export default "__VITE_ASSET__XnlT4Ybr__"